const button = {
    cancel: 'Abbrechen',
    ok: 'OK',

    no: 'Nein',
    yes: 'Ja',
    library: 'Bibliothek',
    save: 'Speichern',
};

export default button;
